import { Link, useLocation } from 'react-router-dom'
import * as analytics from 'lib/analytics'
import Icon from 'components/icons/Icon'
import styles from './styles/NavMenu.css'
import OrganizationLogo from '../misc/OrganizationLogo'

import NavLogin from './NavLogin'
import Btn from '../forms/styles/Button.css'
import classNames from 'classnames'
import authButtonStyles from './styles/NavLogin.css'

const AUTH_PATHS = ['/log-in', '/sign-up']

export const NavMenu = ({ items, organizationLogo = null }) => {
  const location = useLocation()
  const hideAuthButtons = AUTH_PATHS.includes(location.pathname)

  const navClickWrapper = ({ name, onClick = null }) => {
    analytics.event({
      category: 'Nav Dropdown',
      action: `Click ${name}`
    })

    if (onClick) {
      onClick()
    }
  }

  return (
    <div className={styles.navMenu}>
      {items.map(({ name, href, onClick, itemImg, icon, section, viewAll }, i) => {
        const key = name + i
        if (section) {
          return (
            <div key={key} className={styles.sectionHeader}>
              {name}
            </div>
          )
        }
        if (viewAll) {
          return (
            <Link key={key} className={styles.viewAll} to={href}>
              <span className={styles.navItemCopy}>{name}</span>
            </Link>
          )
        }

        const itemIcon = icon ? (
          <Icon name={icon} size={18} className={styles.navItemIcon} />
        ) : itemImg ? (
          <img className={styles.navItemImg} src={itemImg} alt={name} />
        ) : null

        if (/^http/.test(href)) {
          return (
            <a key={key} className={styles.item} href={href} tabIndex={0} target='_blank' rel='noopener noreferrer'>
              {itemIcon}
              <span className={styles.navItemCopy}>{name}</span>
            </a>
          )
        }
        if (href) {
          return (
            <Link key={key} className={styles.item} onClick={() => navClickWrapper({ name, onClick })} to={href || '#'}>
              {itemIcon}
              <span className={styles.navItemCopy}>{name}</span>
            </Link>
          )
        }

        return (
          <button type='button' key={key} className={styles.item} onClick={() => navClickWrapper({ name, onClick })}>
            {itemIcon}
            <span className={styles.navItemCopy}>{name}</span>
          </button>
        )
      })}

      {!hideAuthButtons && (
        <NavLogin
          className={authButtonStyles.mobileButtonLayout}
          key='nav-login'
          showSignup
          signupClassName={classNames(Btn.btn, Btn['btn--blue'], Btn['size--medium'])}
          avatarWrapperMobile={authButtonStyles.avatarWrapperMobile}
        />
      )}

      {organizationLogo && <OrganizationLogo slug={organizationLogo} styles={styles.orgLogo} />}
    </div>
  )
}

export default NavMenu
